module.exports = __webpack_public_path__ + "media/images/top/top_lg-da6dee327f124229e948062011b6ebaa.png";